import * as Yup from 'yup'

Yup.addMethod(Yup.array, 'unique', function(message, mapper = (a) => a) {
  return this.test('unique', message, function(list) {
    return list.length  === new Set(list.map(mapper)).size
  })
})

const MerchantInventoryBatchPutAwaySchema = Yup.object().shape({
  location : Yup.string().required('Required'),
  items    : Yup.array()
    .of(
      Yup.object().shape({
        sku      : Yup.string().required('Required'),
        quantity : Yup.number()
          .positive('Must be more than 0')
          .required('required')
      }))
    .unique('Setiap item harus unik', (item) => item.sku)
    .required('Required')
})

export default MerchantInventoryBatchPutAwaySchema
